import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import queryString from 'query-string'
import * as routes from '../routes'
import { withRouter } from '../shared'
import AudioPlayer from './AudioPlayer'
import { AlertContext } from '../widgets'

const BeatAudioPlayer = (props) => {
  const [state, replaceState] = useState({
    loading: true,

    audioUrl: null,
    artworkUrl: null,
    title: null,
    artist: null,
    is_featured: null,
  })

  const setState = (subState) => {
    replaceState(state => {
      return {...state, ...subState}
    })
  }

  useEffect(() => {
    load()
  }, [])

  const { handleError } = useContext(AlertContext)

  const getId = () => {
    return queryString.parse(props.router.location.search).id
  }

  const load = () => {
    setState({ loading: true })
    axios.get(
      routes.dynamic(routes.getBeatUrl, getId())
    ).then((response) => {
      const {
        audio_file_url,
        audio_stream_url,
        images,
        beat_name,
        producer_name,
        is_featured,
      } = response.data
      setState({
        audioUrl: audio_stream_url || audio_file_url,
        artworkUrl: images['400'],
        title: beat_name,
        artist: producer_name,
        is_featured: is_featured,
      })
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setState({ loading: false })
    })
  }

  return <AudioPlayer {...state} />
}

export default withRouter(BeatAudioPlayer)
